import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-stop-sign-icon',
  templateUrl: './stop-sign-icon.component.html',
  styleUrls: ['./stop-sign-icon.component.scss']
})
export class StopSignIconComponent implements OnInit {

  @Input() height: string = '47';
  @Input() width: string = '48';
  constructor() { }

  ngOnInit() {
  }

}
